var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"checktest-question-view"}},[_c('ChecktestHeader'),_c('ChecktestQuestionForm'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }